export function isClub51Organization( _id = null, organization = null) {
    const c51IDs = ['676353f01ea3041cdd88bc26']
    return c51IDs.includes(_id) || c51IDs.includes(organization)
}

export function isImefOrganization(_id, organization = "") {
  const ImefIds = [
    "66fb2d896646ca001cb93b3f",
    // "6261f728520125001c7ad22f",
    "6724fba1633a0427c816d1d9",
    "67251067633a0427c816d9cb",
    "67254f2d633a0427c8175407",
    "675a1d75737d40001bceb674",
    "67bcc7564db0fa259bfb9608"
  ];

  return (
    ImefIds.includes(_id) || ImefIds.includes(organization)
  );
}

export function isAmpiOrganization(_id = null, organization = null) {
    const ampiIDs = ["62b622c66a7441ae20159d7d", "6297b0fec7bf8b6f826313be"];
    return (ampiIDs.includes(_id) || ampiIDs.includes(organization))
}